export default __webpack_public_path__ + "/dist/images/b2b_active.8a6006a384093126de69ce71ee2c3dfc.svg";